import React from 'react';
import PropTypes from 'prop-types';

import DateAndAuthor from "../../DateAndAuthor";
import LogEntryMarker from "../../LogEntryMarker";
import VariationSku from "./VariationSku";
import JournalValue from "./JournalValue";
import JournalField from "./JournalField";

import {black500, greyishBlue700} from 'assets/jss/main';

JournalEntry.propTypes = {
    field: PropTypes.node.isRequired,
    variationSku: PropTypes.string,
    oldValue: PropTypes.string,
    newValue: PropTypes.string,
    date: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)]).isRequired,
    author: PropTypes.node.isRequired,
    compact: PropTypes.bool,
};

function JournalEntry({action, field, variationSku, oldValue, newValue, date, author, compact = false}) {
    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                width: '100%',
                marginBottom: '12px'
            }}
        >
            <LogEntryMarker />

            <div
                style={{
                    display: 'flex',
                    flex: '1 0 0',
                    minWidth: 0,
                    flexDirection: 'column',
                    justifyContent: 'center',
                    gap: '4px',
                    fontSize: '14px',
                    fontWeight: 400
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        justifyContent: 'space-between',
                        gap: '8px',
                        width: '100%',
                    }}
                >
                    <span style={{color: black500,  lineHeight: 'normal'}}>
                        <JournalField
                            action={action}
                            field={field}
                            hasOldValue={oldValue !== null}
                            hasNewValue={newValue !== null}
                        />
                    </span>

                    {variationSku && <VariationSku sku={variationSku} />}
                </div>

                <span
                    style={compact ? {
                        display: '-webkit-box',
                        WebkitLineClamp: 1,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        wordBreak: 'break-word',
                        overflowWrap: 'anywhere',
                        color: greyishBlue700,
                        lineHeight: 'normal'
                    } : {
                        color: greyishBlue700,
                        lineHeight: 'normal'
                    }}
                >
                    <JournalValue
                        action={action}
                        field={field}
                        oldValue={oldValue}
                        newValue={newValue}
                    />
                </span>
                <DateAndAuthor author={author} date={date} />
            </div>
        </div>
    );
}

export default JournalEntry;
